module.exports = __webpack_public_path__ + "img/88.fbfcb697.png";